import type { TextDiff } from '@/lib/legislationVersionClient';
import ComparisonStats from './ComparisonStats';
import EmptyState from './EmptyState';
import LoadingState from './LoadingState';
import SplitDiffView from './SplitDiffView';
import ViewToggle from './ViewToggle';
import { prepareHtml } from './utils';

interface ComparisonContentProps {
  comparison: TextDiff[];
  isLoading: boolean;
  isComparing: boolean;
  diffView: 'git' | 'split' | 'unified';
  setDiffView: (view: 'git' | 'split' | 'unified') => void;
  versionStats: {
    added: number;
    removed: number;
    unchanged: number;
  };
  getVersionDisplayName: (iri: string) => string;
  currentVersionIri: string;
  selectedVersion2: string;
}

const ComparisonContent = ({
  comparison,
  isLoading,
  isComparing,
  diffView,
  setDiffView,
  versionStats,
  getVersionDisplayName,
  currentVersionIri,
  selectedVersion2,
}: ComparisonContentProps) => {
  if (isLoading || isComparing) {
    return <LoadingState />;
  }

  if (comparison.length === 0) {
    return <EmptyState />;
  }

  const oldText = prepareHtml(comparison[0]?.porovnavane?.text || '');
  const newText = prepareHtml(comparison[0]?.aktualne?.text || '');
  const oldVersionName = getVersionDisplayName(selectedVersion2);
  const newVersionName = currentVersionIri
    ? getVersionDisplayName(currentVersionIri)
    : 'Current version';

  return (
    <div className='border rounded-md overflow-hidden bg-surface-card border-line-default'>
      <div className='border-b px-4 py-3 bg-surface-subtle border-line-default flex justify-between items-center flex-wrap gap-2'>
        <ComparisonStats stats={versionStats} />
        <ViewToggle currentView={diffView} onViewChange={setDiffView} />
      </div>

      <div className='p-4'>
        {/* {diffView === 'git' && (
          <GitDiffView
            oldText={oldText}
            newText={newText}
            oldVersionName={oldVersionName}
            newVersionName={newVersionName}
          />
        )} */}

        {diffView === 'split' && (
          <SplitDiffView
            oldText={oldText}
            newText={newText}
            oldVersionName={oldVersionName}
            newVersionName={newVersionName}
          />
        )}

        {/* {diffView === 'unified' && (
          <UnifiedDiffView oldText={oldText} newText={newText} />
        )} */}
      </div>
    </div>
  );
};

export default ComparisonContent;
